import { render, staticRenderFns } from "./winSearch.vue?vue&type=template&id=5036d9c4&scoped=true"
import script from "./winSearch.vue?vue&type=script&lang=js"
export * from "./winSearch.vue?vue&type=script&lang=js"
import style0 from "./winSearch.vue?vue&type=style&index=0&id=5036d9c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5036d9c4",
  null
  
)

export default component.exports